import { useCreatePath, CreatePathParams } from 'react-admin';

type QueryParamValue = string | number | boolean | null | undefined | object | any[];

export interface QueryParams {
  [key: string]: QueryParamValue;
}

export type PathParams = CreatePathParams & {
  pathSuffix?: string;
};

/**
 * Хук для создания путей с query-параметрами
 *
 * @example
 * const { createPathWithQuery } = useCreatePathWithQuery();
 *
 * // Простой путь с query-параметрами
 * const path = createPathWithQuery(
 *   { resource: 'posts', type: 'list' },
 *   { filter: { status: 'published' }, page: 1 }
 * );
 * // Результат: /posts?filter={"status":"published"}&page=1
 *
 * // Путь с дополнительным суффиксом
 * const pathWithSuffix = createPathWithQuery(
 *   { resource: 'providers', type: 'show', id: '123', pathSuffix: '/1' },
 *   { filter: { active: true } }
 * );
 * // Результат: /providers/123/show/1?filter={"active":true}
 */
export const useCreatePathWithQuery = () => {
  const createPath = useCreatePath();

  function createPathWithQuery(pathParams: PathParams, queryParams: QueryParams = {}): string {
    const { pathSuffix = '', ...createPathParams } = pathParams;
    const basePath = createPath(createPathParams);

    const searchParams = new URLSearchParams();
    Object.entries(queryParams).forEach(([key, value]) => {
      if (value !== null && value !== undefined) {
        searchParams.append(key, typeof value === 'object' ? JSON.stringify(value) : String(value));
      }
    });

    const queryString = searchParams.toString();
    const fullPath = `${basePath}${pathSuffix}`;
    return queryString ? `${fullPath}?${queryString}` : fullPath;
  }

  return { createPathWithQuery };
};
